var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeakIdentifyingAttribute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    opacity: "undefined",
    d: "m153.29169,68c-82.1593,0 -148.70834,-14.76796 -148.70834,-33c0,-18.23204 66.54904,-33 148.70834,-33c82.1593,0 148.70834,14.76796 148.70834,33c0,18.23204 -66.54904,33 -148.70834,33z",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    strokeWidth: 3,
    opacity: "undefined",
    d: "m32.53875,46l242.75074,0",
    id: "svg_2",
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Noto Sans JP",
    fontSize: 24,
    id: "svg_4",
    y: 41,
    x: 25,
    strokeWidth: 0,
    stroke: "#000",
    fill: "#000000"
  }, "Weak Identifying Attribute"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeakIdentifyingAttribute);
export default __webpack_public_path__ + "static/media/WeakIdentifyingAttribute.1825a99b1860d7bf01fdb923524f82ff.svg";
export { ForwardRef as ReactComponent };